enum FileCategory {
  IMAGE,
  VIDEO,
  MEDIA,
  DOCUMENT,
  ALL,
}

export default FileCategory;